import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';

import {
  ReservationCalculatedDataModel,
  ReservationCalculatedDataQueryModel,
  ReservationCreateModel,
  ReservationCreateResultModel,
  ReservationDetailsModel,
  ReservationListModel,
  ReservationUpdateModel,
  ReservationVersion
} from './reservations.model';
import { ListRequestModel, ListResponseModel } from '@app/core/models/crud/list.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReservationsService extends BaseHttpService {
  createReservation(data: ReservationCreateModel): Observable<ReservationCreateResultModel> {
    return this.httpClient.post<ReservationCreateResultModel>(`${this.baseApiUrl}/api/reservation`, data);
  }

  getReservations(request: ListRequestModel): Observable<ListResponseModel<ReservationListModel>> {
    return this.getPage('/api/reservation', request);
  }

  getCalculatedData(query: ReservationCalculatedDataQueryModel): Observable<ReservationCalculatedDataModel> {
    let params = new HttpParams()
      .set('brokerClientId', query.brokerClientId)
      .set('pickupLocationUid', query.pickupLocationUid)
      .set('dateOut', query.dateOut)
      .set('dropOffLocationUid', query.dropOffLocationUid)
      .set('dateIn', query.dateIn);

    if (query.vehicleCategoryUid) {
      params = params.set('vehicleCategoryUid', query.vehicleCategoryUid);
    }

    return this.httpClient.get<ReservationCalculatedDataModel>(`${this.baseApiUrl}/api/reservation/calculatedData`, {
      params
    });
  }

  getReservationDetails(uid: string, version: ReservationVersion = 'latest'): Observable<ReservationDetailsModel> {
    return this.httpClient.get<ReservationDetailsModel>(`${this.baseApiUrl}/api/reservation/${uid}`, {
      params: version && version !== 'latest' ? { version: version.toString() } : {}
    });
  }

  getReservationDetailsByNumber(number: string): Observable<ReservationDetailsModel> {
    return this.getDetails<ReservationDetailsModel>('/api/reservation/getByNumber', number);
  }

  updateReservation(data: ReservationUpdateModel): Observable<void> {
    const body = JSON.stringify(data);
    const options = this.buildOptions();

    return this.httpClient.patch<void>(`${this.baseApiUrl}/api/reservation`, body, options);
  }
}
